import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { AssetService } from '@rd/core/services/asset-service/asset.service';
import { Observable } from 'rxjs';

export class CustomTranslateHttpLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    private assetService: AssetService,
    public prefix: string = '',
    public suffix: string = '',
  ) {}

  /**
   * Gets the translations from the server
   */
  public getTranslation(lang: string): Observable<Object> {
    const i18nPath = this.assetService.getI18nPath(`${lang}.json`);
    return this.http.get(i18nPath);
  }
}
